export * from "./DeviceApiLegacy";
